import React, { createContext, useContext, useState, useEffect } from 'react';
import { trackVisitor, getVisitorCount } from '../services/visitorService';

const VisitorCountContext = createContext();

export const useVisitorCount = () => {
  const context = useContext(VisitorCountContext);
  if (!context) {
    throw new Error('useVisitorCount must be used within VisitorCountProvider');
  }
  return context;
};

export const VisitorCountProvider = ({ children }) => {
  const [visitorCount, setVisitorCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initVisitorCount = async () => {
      try {
        const count = await trackVisitor();
        setVisitorCount(count);
      } catch (error) {
        console.error('Error initializing visitor count:', error);
        try {
          const count = await getVisitorCount();
          setVisitorCount(count);
        } catch (fallbackError) {
          console.error('Error getting visitor count:', fallbackError);
        }
      } finally {
        setLoading(false);
      }
    };

    initVisitorCount();
  }, []); 

  const value = {
    visitorCount,
    loading
  };

  return (
    <VisitorCountContext.Provider value={value}>
      {children}
    </VisitorCountContext.Provider>
  );
};